import RolesList from 'roles';
import CreateRole from './Roles';
import { CREATE_ROLE_ROUTE } from './Roles/common';
import { All_ROLE_ROUTE } from './common';

export default {
    [All_ROLE_ROUTE]: () => <RolesList />,
    [CREATE_ROLE_ROUTE]: () => <CreateRole />,
};
